import { findIndex, map, propEq } from 'ramda';

/**
 * Annote chaque niveau de sa conformité à la CCN.
 */
const withCcnCompliance = (allPricings, minimumCcnCompliantLevel) => {
  const rankOf = (pricingLabel) =>
    findIndex(propEq('pricingLabel', pricingLabel), allPricings);
  const minimumRank = minimumCcnCompliantLevel
    ? rankOf(minimumCcnCompliantLevel)
    : -1;

  return map((pricing) => ({
    ...pricing,
    isMinimaCCN:
      minimumRank > -1 && pricing.pricingLabel === minimumCcnCompliantLevel,
    isConformCCN:
      minimumRank > -1 && rankOf(pricing.pricingLabel) >= minimumRank
  }));
};

export default withCcnCompliance;
